import Splide from '@splidejs/splide';

const splidePresets = {
  platformUpdate: {
    perPage: 2,
    focus: 'start',
    gap: '20px',
    arrows: true,
    pagination: false,
    speed: 600,
    autoWidth: false,
    breakpoints: {
      1280: { perPage: 2, padding: { left: 20, right: 20 } },
      780: { perPage: 1.25, padding: { left: 20, right: 20 } },
    }
  },
  default: {
    type: 'loop',
    classes: {
      pagination: 'po-post-slider__slider-nav',
      page: 'po-post-slider__pagination-page',
    },
    perPage: 3,
    perMove: 1,
    gap: '20px',
    pagination: true,
    arrows: true,
    interval: 3000,
    speed: 600,
    breakpoints: {
      1280: { perPage: 2.5, padding: { left: 20, right: 20 } },
      780: { perPage: 1.5, padding: { left: 20, right: 20 } },
    },
  }
};

export function initSplideSlider() {
  document
      .querySelectorAll('.po-post-slider__slider .splide')
      .forEach((slider) => {
        const preset = slider.dataset.preset || "default";
        new Splide(slider, splidePresets[preset]).mount();
      });
}